import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FooterScene from './FooterScene';
import FooterContent from './FooterContent';
import FooterServices from '../../../services/Footer';

const FooterWrapper = styled.div`
  width: 100%;
  position: relative;
  bottom: 0;
`;

const Footer = ({ gradient }) => {
  const [links, setLinks] = useState(null);

  const fetchData = async () => {
    FooterServices.getData()
      .then(res => {
        const [footerLinks] = res;
        setLinks(footerLinks);
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchData();
  }, []);

  return links ? (
    <FooterWrapper>
      {!gradient && <FooterScene />}
      <FooterContent gradient={gradient} links={links} />
    </FooterWrapper>
  ) : null;
};

Footer.propTypes = {
  gradient: PropTypes.bool,
};

Footer.defaultProps = {
  gradient: false,
};

export default Footer;
